import React, { PropTypes } from 'react';

import { LessonCard, LessonCardCreate } from '../';

import CardList from '../../../Dashboard/Containers/CardsList/CardsList';

const LessonsList = ({ lessons, removeLesson, getLessonsList }) => (
  <CardList
    id="lessons"
    cardPerRow={2}
    list={lessons}
    cardComponent={LessonCard}
    createCard={LessonCardCreate}
    removeLesson={removeLesson}
    getLessonsList={getLessonsList}
  />
);

export default LessonsList;



// WEBPACK FOOTER //
// ./src/modules/Lessons/Components/LessonsList/LessonsList.js